import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./AddOnModal.css";
import Blue_Btn from "../../Common-Component/common_btn/blue_btn/Blue_Btn";
import Dark_Blue_Btn from "../../Common-Component/common_btn/dark_blue_btn/Dark_Blue_Btn";

function AddOnModal({ show, handleClose }) {
  const [selected, setSelected] = useState([]);

  const addOns = [
    { title: "I Phone 20w Charger", price: "₹ 2000.00" },
    { title: "Premium Hard Case", price: "₹ 340.00" },
    { title: "Guard 360 Screen Glass", price: "₹ 100.00" },
    { title: "Camera Glass Protector", price: "₹ 100.00" },
  ];

  const handleCheck = (item) => {
    setSelected((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="addon_modal">
      <Modal.Header closeButton>
        <Modal.Title className="addon_title">Add On</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="addon_list">
          {addOns.map((item, index) => (
            <div className="addon_row" key={index}>
              <div>
                <p>{item.title}</p>
              </div>
              <div className="d-flex gap-3">

                <p>{item.price}</p>
                <Form.Check
                className="addon_checkbox"
                  type="checkbox"
                  checked={selected.includes(item.title)}
                  onChange={() => handleCheck(item.title)}
                 
                />
              </div>
            </div>
          ))}
        </div>

        <div className="addon_btn_holder">
          <Dark_Blue_Btn btn_name="Add Items"/>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddOnModal;
